import React from 'react';
import { File, Download, AlertTriangle, RefreshCw, Trash2 } from 'lucide-react';
import { cn } from '../lib/utils';

/**
 * Ficha de un adjunto ya subido: nombre, descarga, borrado si se pasa
 * `onDelete` y — si el aviso por correo falló — el motivo con un botón para
 * reintentarlo.
 */
export default function AttachmentRow({ attachment, busy, iconClass, onDownload, onDelete, onResend, failedLabel }) {
  if (!attachment) return null;

  return (
    <div className="bg-muted/40 rounded-md px-2 py-1.5 space-y-1.5">
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <File className={cn('h-3 w-3 shrink-0', iconClass)} />
        <span className="truncate flex-1" title={attachment.filename}>
          {attachment.filename}
        </span>
        {!attachment.legacy && (
          <button
            type="button"
            onClick={onDownload}
            title="Descargar"
            className="shrink-0 p-0.5 hover:text-primary transition-colors"
          >
            <Download className="h-3.5 w-3.5" />
          </button>
        )}
        {onDelete && (
          <button
            type="button"
            onClick={onDelete}
            disabled={busy}
            title="Borrar"
            aria-label={`Borrar ${attachment.filename}`}
            className="shrink-0 p-0.5 hover:text-destructive transition-colors disabled:opacity-50"
          >
            <Trash2 className="h-3.5 w-3.5" />
          </button>
        )}
      </div>

      {/* Subido cuando el fichero vivía en n8n: no hay nada que descargar. */}
      {attachment.legacy && (
        <div className="text-[11px] text-muted-foreground">
          Subido antes de la migración — el archivo no está en el panel
        </div>
      )}

      {attachment.notification?.status === 'failed' && (
        <div className="flex items-center gap-2 text-[11px] text-destructive">
          <AlertTriangle className="h-3 w-3 shrink-0" />
          <span className="flex-1 truncate" title={attachment.notification.error}>
            {failedLabel}
          </span>
          <button
            type="button"
            onClick={onResend}
            disabled={busy}
            className="shrink-0 inline-flex items-center gap-1 font-medium hover:underline disabled:opacity-50"
          >
            <RefreshCw className={cn('h-3 w-3', busy && 'animate-spin')} />
            Reintentar
          </button>
        </div>
      )}
    </div>
  );
}
